/*
DJAS/RQ! added this JS file for custom changes
*/

/* DJAS/RQ! - make all .media-card__content and .profile__content height equal STARTS */
(function () {
  function equalizeGroup(selector) {
    var items = document.querySelectorAll(selector);
    if (!items.length) return;

    items.forEach(function (el) { el.style.minHeight = ''; });

    var max = 0;
    items.forEach(function (el) {
      var h = el.getBoundingClientRect().height;
      if (h > max) max = h;
    });

    items.forEach(function (el) { el.style.minHeight = max + 'px'; });
  }

  function equalizeAll() {
    equalizeGroup('.media-card__content'); // "Professional grade healthcare" cards
    equalizeGroup('.profile__content');    // "Healthcare Facilities / Pharmacies / Med-Surg" cards
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  var run = debounce(equalizeAll, 150);

  document.addEventListener('DOMContentLoaded', equalizeAll);
  window.addEventListener('resize', run);
  window.addEventListener('load', equalizeAll);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(equalizeAll);
  }
})();
/* DJAS/RQ! - make all .media-card__content and .profile__content height equal ENDS */